import Image from '../Image';
import { useModal } from "../../context/ModalContext";
import Button from '../Button';
import '../../assets/styles/modals/modalCardBase.css'

const ModalCardBase = ({data}) => {
 const { closeModal } = useModal();

    if (!data) return null;

  return (
    <div className="ModalCard modal-base">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-start">
                <div className="col-12 col-lg-auto px-0">
                    <div className="thumb">
                        <Image image={data.image} title={data.title} />
                    </div>
                </div>
                <div className="col-11 col-lg">
                    <div className="box-content">
                        <h2 className='text-center title' dangerouslySetInnerHTML={{ __html: data.title }} />
                        <p className='text-center subtitle' dangerouslySetInnerHTML={{ __html: data.subtitle }} />
                        <div>
                            <div className='content-items'>
                                {data.items?.map((text, idx) => (
                                    <div key={idx} className='line'>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="#6DAE68"
                                        viewBox="0 0 16 16"
                                        style={{ flexShrink: 0, marginTop: "5px" }}
                                    >
                                        <path d="M12.0001 1.07191C13.2068 1.7686 14.2105 2.76833 14.912 3.97215C15.6135 5.17597 15.9885 6.54213 15.9997 7.93538C16.011 9.32864 15.6582 10.7007 14.9762 11.9157C14.2942 13.1307 13.3068 14.1465 12.1115 14.8626C10.9163 15.5787 9.55481 15.9702 8.16178 15.9984C6.76875 16.0266 5.39251 15.6904 4.16929 15.0233C2.94608 14.3562 1.91832 13.3811 1.18775 12.1947C0.457175 11.0083 0.049128 9.65168 0.00400014 8.25911L0 7.99991L0.00400014 7.74071C0.0488032 6.3591 0.450844 5.01268 1.17093 3.83271C1.89101 2.65273 2.90456 1.67948 4.11276 1.00782C5.32097 0.336164 6.6826 -0.0109686 8.0649 0.000264197C9.44721 0.011497 10.803 0.380712 12.0001 1.07191ZM10.9657 5.83431C10.828 5.69657 10.6447 5.61383 10.4503 5.6016C10.2559 5.58938 10.0636 5.64851 9.90972 5.76791L9.83452 5.83431L7.20009 8.46791L6.16568 7.43431L6.09048 7.36791C5.93654 7.2486 5.74437 7.18953 5.54999 7.20179C5.35562 7.21406 5.17239 7.29681 5.03467 7.43452C4.89695 7.57224 4.81421 7.75546 4.80194 7.94984C4.78968 8.14421 4.84874 8.33638 4.96806 8.49031L5.03446 8.56551L6.63448 10.1655L6.70968 10.2319C6.84998 10.3408 7.02251 10.3998 7.20009 10.3998C7.37767 10.3998 7.55019 10.3408 7.69049 10.2319L7.7657 10.1655L10.9657 6.96551L11.0321 6.89031C11.1515 6.73639 11.2107 6.54419 11.1984 6.34977C11.1862 6.15535 11.1035 5.97207 10.9657 5.83431Z" />
                                    </svg>
                                    <p className='m-0' dangerouslySetInnerHTML={{ __html: text }}/>
                                    </div>
                                ))}
                                </div>
                            </div>
                        <h4 className="price">A partir de <strong>{(
                                            (data.price*.9) / 30
                                        ).toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                            maximumFractionDigits: 0,
                                        })}</strong><small>/dia</small></h4>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-auto">
                    {data?.button && (
                        <Button 
                            classes="major master" 
                            label={data.button.label} 
                            onClick={data.button.onClick}
                        />
                    )}
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                    <div className={data?.footerBg ? "footer-background" : "footer-placeholder"}></div>
            </div>
        </div>
    </div>
  );
};

export default ModalCardBase;
